"use strict";

import "./CollaboratorCard.css";
import React from "react";
import lang from "vwa/lang";
import Card from "vwa/components/Card";
import Button from "vwa/components/Button";
import Select from "vwa/components/Select";

export default class CollaboratorCard extends React.Component {
	
	render() {
		return (
			<Card className="CollaboratorCard">
				<header>
					<div id="nameContainer">
						<h1>{this.props.name}</h1>
						<h2>{this.props.isGroup ? lang._GROUP : ""}</h2>
					</div>
					<Button
						icon="close"
						className={this.props.canClear ? "" : "Hidden"}
						onClick={_ => this.props.onClear()}
					/>
				</header>
				<div>
					<Select
						disabled={!this.props.canChange}
						value={this.props.privilege}
						onChange={evt => this.props.onChange(parseInt(evt.target.value))}
					>
						<option value={1}>{lang.CAN_VIEW}</option>
						<option value={2}>{lang.CAN_EDIT}</option>
						<option value={3}>{lang.CAN_SHARE}</option>
						<option value={4}>{lang.CAN_DELETE}</option>
					</Select>
				</div>
			</Card>
		);
	}
	
}

CollaboratorCard.propTypes = {
	name:		React.PropTypes.string,
	privilege:	React.PropTypes.number,
	isGroup:	React.PropTypes.bool,
	canClear:	React.PropTypes.bool,
	canChange:	React.PropTypes.bool,
	onClear:	React.PropTypes.func,
	onChange:	React.PropTypes.func
};

CollaboratorCard.defaultProps = {
	name:		"",
	privilege:	0,
	isGroup:	false,
	canClear:	false,
	canChange:	false,
	onClear:	() => {},
	onChange:	privilege => {}
};


// WEBPACK FOOTER //
// ./src/view/POICollaborators/CollaboratorCard/CollaboratorCard.jsx